<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
  <div class="row">
      <div class="col-md-3">
          <nav id="secondary-navigation">
              <!-- Header -->
              <header class="header">
                  <h5>Infrastructure</h5>
              </header>
              <!-- /Header -->
              <ul>
                <li routerLinkActive="active">
                    <a routerLink="/infrastructure/campus" >Campus</a>
                </li>
                  <li routerLinkActive="active">
                      <a routerLink="/infrastructure/computer" >Computer Education</a>
                  </li>
                  <li routerLinkActive="active">
                    <a routerLink="/infrastructure/smart" >Smart Boards</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/infrastructure/labs" >Labs</a>
              </li>
                  <li routerLinkActive="active">
                      <a routerLink="/infrastructure/library" >Library</a>
                  </li>
                  <li routerLinkActive="active">
                      <a routerLink="/infrastructure/activity" >Activity Room</a>
                  </li>

                  <li routerLinkActive="active">
                    <a routerLink="/infrastructure/medical" >Medical Room</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/infrastructure/school" >School Counselor</a>
              </li>
              <li routerLinkActive="active">
                <a routerLink="/infrastructure/surveillance" >Surveillance</a>
            </li>
            <li routerLinkActive="active">
              <a routerLink="/infrastructure/fire" >Fire Fighting Equipment</a>
          </li>
          <li routerLinkActive="active">
            <a routerLink="/infrastructure/cafeteria" >Cafeteria</a>
        </li>
        <li routerLinkActive="active">
          <a routerLink="/infrastructure/transport" >Transport</a>
      </li>
        <li routerLinkActive="active">
          <a routerLink="/infrastructure/herbal" >Herbal Garden– Playground</a>
      </li>
                  
              </ul>
          </nav>
      </div>
      <div class="col-md-9">
          <router-outlet></router-outlet>
      </div>
  </div>
</div>